/**
 * Map Data Utilities
 *
 * Pure functions for transforming data into map location format.
 * No Google Maps API dependency.
 */

function getMapLabel(facility) {
	if (facility.lowestPrice != null) return `$${facility.lowestPrice}`;
	if (facility.startingPrice != null) return `$${facility.startingPrice}`;
	return facility.name ?? "";
}

/**
 * Convert facility cards to map location format for GoogleMap component
 *
 * @param {Array} facilityCards - Array of facility card objects
 * @returns {Array} Array of map location objects with id, latitude, longitude, and label
 */
export function facilityCardsToMapLocations(facilityCards) {
	return facilityCards
		.filter((facility) => facility.schema?.location?.latitude)
		.map((facility) => ({
			id: facility.id,
			latitude: facility.schema.location.latitude,
			longitude: facility.schema.location.longitude,
			label: getMapLabel(facility)
		}));
}
